import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { ErrorMessage } from "@hookform/error-message";

// Money input via react-number-format: thousands separators format LIVE as you
// type with correct caret handling (no jump), and the value stored in the form
// is the raw unformatted number string. The Annual Income hint and the min/max
// messages update live off the same value. Best-practice replacement for the
// old Inputmask approach.
const usd = (n) =>
  Number(n).toLocaleString("en-US", { style: "currency", currency: "USD" });

const Currency = ({
  field_id,
  field_label,
  field_placeholder,
  field_value,
  validation,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  let validationObj = {};
  try {
    validationObj = validation ? JSON.parse(validation) : {};
  } catch (e) {
    validationObj = {};
  }

  const isAmt =
    field_id === "2ndmortgage_amount_requested" || field_id === "2ndmortgage_amount";

  return (
    <div className="mb-3">
      <label htmlFor={field_id} className="form-label">
        {field_label}
      </label>
      <Controller
        control={control}
        name={field_id}
        rules={{
          required: {
            value: !!validationObj.required,
            message:
              field_id === "1stmortgage_amount"
                ? "Enter '0' if you're looking for a first lien loan."
                : "This is a required field",
          },
        }}
        render={({ field }) => {
          const raw = field.value == null ? "" : String(field.value);
          const num = raw === "" ? NaN : Number(raw.replace(/,/g, ""));
          const min = validationObj.min_value;
          const max = validationObj.max_value;
          return (
            <>
              <NumericFormat
                id={field_id}
                className="form-control"
                thousandSeparator=","
                allowNegative={false}
                valueIsNumericString
                inputMode="decimal"
                placeholder={field_placeholder ? field_placeholder : ""}
                value={raw}
                getInputRef={field.ref}
                onValueChange={(v) => field.onChange(v.value)}
                onBlur={field.onBlur}
              />
              {field_id === "combined_annual_income" && !isNaN(num) && num > 0 && (
                <small className="form-text text-black">
                  Annual Income: {usd(num * 12)}
                </small>
              )}
              {isAmt && !isNaN(num) && min != null && num < min && (
                <small>Minimum Loan Amount is {usd(min)}</small>
              )}
              {isAmt && !isNaN(num) && max != null && num > max && (
                <small>Maximum Loan Amount is {usd(max)}</small>
              )}
              {field_id === "home_value" && !isNaN(num) && min != null && num < min && (
                <small>Minimum Home Value must be {usd(min)}</small>
              )}
            </>
          );
        }}
      />
      <ErrorMessage
        errors={errors}
        name={field_id}
        render={({ message }) => <p className="fb-error-message">{message}</p>}
      />
    </div>
  );
};

export default Currency;
